import React, { useState } from "react";
import Footer from "./Footer";
import Banner from "./Banner";
import Our_partner from "./Our_partner";
import Previous_partner from "./Previous_partner";
import Our_Services from "./Our_Services";

import { Swiper, SwiperSlide } from "swiper/react";
import rohit_shrma from "../pictures/rohit_shrma.jpg";
import sandeep_patil from "../pictures/sandeep_patil.jpg";
import sehwag_img from "../pictures/sehwag_img.jpg";
import jksingh from "../pictures/jksingh.jpg";
import basandkumar from "../pictures/basandkumar.jpg";
import chetanChauhan from "../pictures/chetanChauhan.jpg";
import chetanshrma from "../pictures/chetansharma.jpg";
import laradutta from "../pictures/laradutta.jpg";
import rajaggrarwal from "../pictures/rajaggarwal.jpg";
import yogan from "../pictures/yoganandshastri.jpg";
import { EffectCoverflow, Pagination, Scrollbar, A11y } from "swiper/modules";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import img1 from "../gallery/img1.jpg";
import img2 from "../gallery/img2.jpg";
import img3 from "../gallery/img3.jpg";
import img4 from "../gallery/img4.jpg";
import img5 from "../gallery/img5.jpg";
import img6 from "../gallery/img6.jpg";
import img7 from "../gallery/img7.jpg";
import img8 from "../gallery/img8.jpg";
import img9 from "../gallery/img9.jpg";
import img10 from "../gallery/img10.jpg";
import img11 from "../gallery/img11.jpg";
import img12 from "../gallery/img12.jpg";
import img13 from "../gallery/img13.jpg";
import img14 from "../gallery/img14.jpg";
import img15 from "../gallery/img15.jpg";
import img16 from "../gallery/img16.jpg";
import img17 from "../gallery/img17.jpg";
import img18 from "../gallery/img18.jpg";
import img19 from "../gallery/img19.jpg";
import img20 from "../gallery/img20.jpg";
import img21 from "../gallery/img21.jpg";
import img22 from "../gallery/img22.jpg";
import img23 from "../gallery/img23.jpg";
import img24 from "../gallery/img24.jpg";
import educationimg from "../pictures/education.png";
import leadershipimg from "../pictures/leadershipimg.png";
import icon from "../pictures/icon.png";
import brandimg from "../pictures/brandimg.png";
import healthcare from "../pictures/healthcare.png";
import Questions from "./Questions";

import { AiOutlineCalendar } from "react-icons/ai";
import { PiSpeakerSimpleHighBold } from "react-icons/pi";
import { FaChair } from "react-icons/fa";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";

const Home = () => {
  const [counterStart, setCounterStart] = useState(false);

  return (
    <>
      <Banner />

      <div className="home_header">
        <h1 className="home_header">OUR PREVIOUS GUEST & SPEAKER</h1>
      </div>

      <div className="home_swiper_container">
        <Swiper
          modules={[Pagination, Scrollbar, A11y, EffectCoverflow]}
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={true}
          scrollbar={{ draggable: true }}
          onSlideChange={() => console.log("slide change")}
          onSwiper={(swiper) => console.log(swiper)}
        >
          <SwiperSlide>
            <div className="swiper_card">
              <img src={rohit_shrma} alt="not" />
              <h2>Indian Cricketer</h2>
              <h1>Mr.Rohit Sharma</h1>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="swiper_card">
              <img src={sandeep_patil} alt="not" />
              <h2>
                Former Indian Cricketer & Chief of the BCCL SelectionCommitee
              </h2>
              <h1>Shri Sandeep Patil</h1>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="swiper_card">
              <img src={sehwag_img} alt="not" />
              <h2>Former Indian Cricketer</h2>
              <h1>Shri Virender Sehwag</h1>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="swiper_card">
              <img src={jksingh} alt="not" />
              <h2>
                Present, Cancer Care India Former National Vice Present, India
                Mediacal Association
              </h2>
              <h1>Padma Shri Dr.j.k Singh</h1>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="swiper_card">
              <img src={basandkumar} alt="not" />
              <h2>Advisor, Micro, Small & Medium Enterprises (MSME)</h2>
              <h1>Shri. Vasant Kumar</h1>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="swiper_card">
              <img src={chetanChauhan} alt="not" />
              <h2>
                Hon'ble Minister of Youth & Sports, Vocational Education,
                Skilled Development of Utter Presdesh
              </h2>
              <h1>Shri Chetan Chauhan</h1>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="swiper_card">
              <img src={chetanshrma} alt="not" />
              <h2>Former Indian Cricketer</h2>
              <h1>Shri Chetan Sharma</h1>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="swiper_card">
              <img src={laradutta} alt="not" />
              <h2>Bollywood Actress</h2>
              <h1>Mrs.Lara Dutta</h1>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="swiper_card">
              <img src={rajaggrarwal} alt="not" />
              <h2>Directot of AIMA-CME</h2>
              <h1>Dr. Raj Aggarwal</h1>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="swiper_card">
              <img src={yogan} alt="not" />
              <h2>Former Speraker, Delhi Legislative Assembly</h2>
              <h1>Dr. Yoganada Shastri</h1>
            </div>
          </SwiperSlide>
        </Swiper>

        {/* <button src='/Guest_And_Speaker'>
          <span class="transition"></span>
          <span class="gradient"></span>
          <span class="label">See More</span>
        </button> */}
      </div>

      <ScrollTrigger
        onEnter={() => setCounterStart(true)}
        onExit={() => setCounterStart(false)}
      >
        <section className="section section_work_data">
          <div className="work_data_conatainer">
            <div className="work_number nomination">
              <span>
                {" "}
                <AiOutlineCalendar size={50} />
              </span>
              <h2>
                {counterStart && (
                  <CountUp start={0} end={48507} duration={2} delay={0} />
                )}{" "}
                +
              </h2>
              <p>Nominations</p>
            </div>
            <div className="work_number nomination">
              <span>
                {" "}
                <PiSpeakerSimpleHighBold size={50} />{" "}
              </span>
              <h2>
                {counterStart && (
                  <CountUp start={0} end={43} duration={4} delay={0} />
                )}{" "}
                +
              </h2>
              <p>Great Speaker</p>
            </div>
            <div className="work_number nomination">
              <span>
                <FaChair size={50} />
              </span>
              <h2>
                {counterStart && (
                  <CountUp start={0} end={130} duration={4} delay={0} />
                )}{" "}
                +
              </h2>
              <p>Category</p>
            </div>
          </div>
        </section>
      </ScrollTrigger>

      <ScrollTrigger
        onEnter={() => setCounterStart(true)}
        onExit={() => setCounterStart(false)}
      >
        <section className="section_mobile section_work_data">
          <div className="work_data_conatainer_mobile">
            <div className="work_number_mobile nomination">
              <span>
                {" "}
                <AiOutlineCalendar size={30} />
              </span>
              <h2>
                {counterStart && (
                  <CountUp start={0} end={48507} duration={2} delay={0} />
                )}{" "}
                +
              </h2>
              <p>Nominations</p>
            </div>
            <div className="work_number_mobile nomination">
              <span>
                {" "}
                <PiSpeakerSimpleHighBold size={30} />{" "}
              </span>
              <h2>
                {counterStart && (
                  <CountUp start={0} end={43} duration={4} delay={0} />
                )}{" "}
                +
              </h2>
              <p>Great Speaker</p>
            </div>
            <div className="work_number_mobile nomination">
              <span>
                <FaChair size={30} />
              </span>
              <h2>
                {counterStart && (
                  <CountUp start={0} end={130} duration={4} delay={0} />
                )}{" "}
                +
              </h2>
              <p>Category</p>
            </div>
          </div>
        </section>
      </ScrollTrigger>

      <ScrollTrigger
        onEnter={() => setCounterStart(true)}
        onExit={() => setCounterStart(false)}
      >
        <section className="section_tab section_work_data">
          <div className="work_data_conatainer_tab">
            <div className="work_number_tab nomination">
              <span>
                {" "}
                <AiOutlineCalendar size={40} />
              </span>
              <h2>
                {counterStart && (
                  <CountUp start={0} end={48507} duration={2} delay={0} />
                )}{" "}
                +
              </h2>
              <p>Nominations</p>
            </div>
            <div className="work_number_tab nomination">
              <span>
                {" "}
                <PiSpeakerSimpleHighBold size={40} />{" "}
              </span>
              <h2>
                {counterStart && (
                  <CountUp start={0} end={43} duration={4} delay={0} />
                )}{" "}
                +
              </h2>
              <p>Great Speaker</p>
            </div>
            <div className="work_number_tab nomination">
              <span>
                <FaChair size={40} />
              </span>
              <h2>
                {counterStart && (
                  <CountUp start={0} end={130} duration={4} delay={0} />
                )}{" "}
                +
              </h2>
              <p>Category</p>
            </div>
          </div>
        </section>
      </ScrollTrigger>

      <div className="home_header">
        <h1 className="home_header">OUR PARTNERS</h1>
      </div>

      <Our_partner />

      <div className="home_header">
        <h1 className="home_header">PREVIOUSE PARTNERS</h1>
      </div>

      <Previous_partner />

      <div className="home_header">
        <h1 className="home_header">GALLERY</h1>
      </div>

      <div className="home_gallery">
        <div className="home_row home_card_row1">
          <div className="home_gallery_img">
            <img src={img1} alt="not" />
          </div>
          <div className="home_gallery_img">
            <img src={img2} alt="not" />
          </div>
          <div className="home_gallery_img">
            <img src={img3} alt="not" />
          </div>
        </div>
        <div className="home_row home_card_row2">
          <div className="home_gallery_img">
            <img src={img4} alt="not" />
          </div>
          <div className="home_gallery_img">
            <img src={img5} alt="not" />
          </div>
          <div className="home_gallery_img">
            <img src={img6} alt="not" />
          </div>
        </div>
        <div className="home_row home_card_row3">
          <div className="home_gallery_img">
            <img src={img7} alt="not" />
          </div>
          <div className="home_gallery_img">
            <img src={img8} alt="not" />
          </div>
          <div className="home_gallery_img">
            <img src={img9} alt="not" />
          </div>
        </div>
        <div className="home_row home_card_row4">
          <div className="home_gallery_img">
            <img src={img10} alt="not" />
          </div>
          <div className="home_gallery_img">
            <img src={img11} alt="not" />
          </div>
          <div className="home_gallery_img">
            <img src={img12} alt="not" />
          </div>
        </div>
        <div className="home_row home_card_row5">
          <div className="home_gallery_img">
            <img src={img13} alt="not" />
          </div>
          <div className="home_gallery_img">
            <img src={img14} alt="not" />
          </div>
          <div className="home_gallery_img">
            <img src={img15} alt="not" />
          </div>
        </div>
        <div className="home_row home_card_row6">
          <div className="home_gallery_img">
            <img src={img16} alt="not" />
          </div>
          <div className="home_gallery_img">
            <img src={img17} alt="not" />
          </div>
          <div className="home_gallery_img">
            <img src={img18} alt="not" />
          </div>
        </div>
        <div className="home_row home_card_row7">
          <div className="home_gallery_img">
            <img src={img19} alt="not" />
          </div>
          <div className="home_gallery_img">
            <img src={img20} alt="not" />
          </div>
          <div className="home_gallery_img">
            <img src={img21} alt="not" />
          </div>
        </div>
        <div className="home_row home_card_row8">
          <div className="home_gallery_img">
            <img src={img22} alt="not" />
          </div>
          <div className="home_gallery_img">
            <img src={img23} alt="not" />
          </div>
          <div className="home_gallery_img">
            <img src={img24} alt="not" />
          </div>
        </div>
      </div>

      <div className="tab_home_gallery">
        <div className="tab_home_row tab_card_row1">
          <div className="tab_home_gallery_img">
            <img src={img1} alt="not" />
          </div>
          <div className="tab_home_gallery_img">
            <img src={img2} alt="not" />
          </div>
        </div>

        <div className="tab_home_row tab_card_row2">
         <div className="tab_home_gallery_img">
            <img src={img3} alt="not" />
          </div>
          <div className="tab_home_gallery_img">
            <img src={img4} alt="not" />
          </div>
        </div>

        <div className="tab_home_row tab_card_row3">
          <div className="tab_home_gallery_img">
            <img src={img5} alt="not" />
          </div>
          <div className="tab_home_gallery_img">
            <img src={img6} alt="not" />
          </div>
        </div>

        <div className="tab_home_row tab_card_row4">
          <div className="tab_home_gallery_img">
            <img src={img7} alt="not" />
          </div>
          <div className="tab_home_gallery_img">
            <img src={img8} alt="not" />
          </div>
        </div>

        <div className="tab_home_row tab_card_row5">
           <div className="tab_home_gallery_img">
            <img src={img9} alt="not" />
          </div>
           <div className="tab_home_gallery_img">
            <img src={img10} alt="not" />
          </div>
        </div>

        <div className="tab_home_row tab_card_row6">
          <div className="tab_home_gallery_img">
            <img src={img11} alt="not" />
          </div>
          <div className="tab_home_gallery_img">
            <img src={img12} alt="not" />
          </div>
        </div>

        <div className="tab_home_row tab_card_row7">
          <div className="tab_home_gallery_img">
            <img src={img13} alt="not" />
          </div>
          <div className="tab_home_gallery_img">
            <img src={img14} alt="not" />
          </div>
        </div>

          <div className="tab_home_row tab_card_row8">
          <div className="tab_home_gallery_img">
            <img src={img15} alt="not" />
            </div>
            <div className="tab_home_gallery_img">
            <img src={img16} alt="not" />
            </div>
          </div>

        <div className="tab_home_row tab_card_row9">
          <div className="tab_home_gallery_img">
            <img src={img17} alt="not" />
          </div>
          <div className="tab_home_gallery_img">
            <img src={img18} alt="not" />
          </div>
        </div>

        <div className="tab_home_row tab_card_row10">
          <div className="tab_home_gallery_img">
            <img src={img19} alt="not" />
          </div> 
          <div className="tab_home_gallery_img">
            <img src={img20} alt="not" />
          </div>
        </div>

        <div className="tab_home_row tab_card_row11">
         <div className="tab_home_gallery_img">
            <img src={img21} alt="not" />
          </div>
          <div className="tab_home_gallery_img">
            <img src={img22} alt="not" />
          </div>
        </div>

        <div className="tab_home_row tab_card_row12"> 
          <div className="tab_home_gallery_img">
            <img src={img23} alt="not" />
          </div>
          <div className="tab_home_gallery_img">
            <img src={img24} alt="not" />
          </div>
        </div>
      </div>

      <div className="home_header">
        <h1 className="home_header">VIDEO</h1>
      </div>

      <div className="home_video">
        <div className="video_row">
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/FO9KwVu_GyA"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/MBoNTrPLeZI"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/f_G1z3GVXKY"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
        </div>
        <div className="video_row">
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/LuCukRXeE_s"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/T7QmEyVpDlU"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/VPZn7r7VaMU"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video_row">
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/dEYs847mt_w"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/wh7zwl0SUF4"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/QC-9EHL0k6M"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video_row">
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/I0zMuwAthv4"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="360"
              src="https://www.youtube.com/embed/vM1bUk6zKIo"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/iH9YXUd0OsU"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video_row">
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/ud3nEkSLVcI"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/ub5Vx-JTtk8"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/2kwDDptgVng"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video_row">
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/Ovq_JuoePmA"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/9gWHKmnvnT8"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video">
            <iframe
              width="400"
              height="300"
              src="https://www.youtube.com/embed/deFaIPp60Qk"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>

      <div className="home_video_mobile">
        <div className="video_row_mobile">
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/FO9KwVu_GyA"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/MBoNTrPLeZI"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/f_G1z3GVXKY"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
        </div>
        <div className="video_row_mobile">
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/LuCukRXeE_s"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/T7QmEyVpDlU"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/VPZn7r7VaMU"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video_row_mobile">
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/dEYs847mt_w"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/wh7zwl0SUF4"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video_row_mobile">
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/I0zMuwAthv4"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/vM1bUk6zKIo"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/iH9YXUd0OsU"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video_row_mobile">
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/ud3nEkSLVcI"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/ub5Vx-JTtk8"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/2kwDDptgVng"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video_row_mobile">
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/Ovq_JuoePmA"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/9gWHKmnvnT8"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_mobile">
            <iframe
              width="300"
              height="250"
              src="https://www.youtube.com/embed/deFaIPp60Qk"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>

      <div className="home_video_tab">
        <div className="video_row_tab">
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/FO9KwVu_GyA"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/MBoNTrPLeZI"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/f_G1z3GVXKY"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
        </div>
        <div className="video_row_tab">
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/LuCukRXeE_s"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/T7QmEyVpDlU"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/VPZn7r7VaMU"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video_row_tab">
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/dEYs847mt_w"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/wh7zwl0SUF4"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video_row_tab">
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/I0zMuwAthv4"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/vM1bUk6zKIo"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/iH9YXUd0OsU"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video_row_tab">
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/ud3nEkSLVcI"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/ub5Vx-JTtk8"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/2kwDDptgVng"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="video_row_tab">
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/Ovq_JuoePmA"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullscreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/9gWHKmnvnT8"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="home_youtube_video_tab">
            <iframe
              width="560"
              height="350"
              src="https://www.youtube.com/embed/deFaIPp60Qk"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>

      <div className="register_container">
        <div className="register">
          <div className="regiter_content">
            <h1>
              We Are Passionate About Our <br /> Work & Cover Best For You
            </h1>
            <button className="btn">Register Now</button>
          </div>
          <div className="education_img">
            <img src={educationimg} alt="not" />
          </div>
        </div>
      </div>

      <div className="home_header">
        <h1 className="home_header">OTHER AWARDS</h1>
      </div>

      <div className="leadership_award_container">
        <div className="leadership_award_content">
          <div className="leadership_img">
            <img src={leadershipimg} alt="not" />
          </div>
          <div className="leadership_info">
            <h2>INTERNATIONAL LEADERSHIP AWARDS</h2>
            <p>
              TIME Cybermedia Private Limited award the International Leadership
              Award to honor
            </p>
            <br />
            <p>
              outstanding performance in a wide range of categories and
              industries to ensure that
            </p>
            <br />
            <p>
              achievements in across all fields are acknowledged. The
              accomplishments of the awardees
            </p>
            <br />
            <p>raise the bar and inspire others to advance.</p>
            <button className="btn">
              <u>READ MORE</u>
            </button>
          </div>
        </div>
      </div>

      <div className="icon_award_container">
        <div className="icon_award_content">
          <div className="icon_img">
            <img src={icon} alt="not" />
          </div>
          <div className="icon_info">
            <h2>INDIAN ICON OF THE YEAR</h2>
            <p>
              TIME Cybermedia Private Limited award the International Leadership
              Award to honor
            </p>
            <br />
            <p>
              outstanding performance in a wide range of categories and
              industries to ensure that
            </p>
            <br />
            <p>
              achievements in across all fields are acknowledged. The
              accomplishments of the
            </p>
            <br />
            <p>awardees raise the bar and inspire others to advance.</p>
            <button className="btn">
              <u>READ MORE</u>
            </button>
          </div>
        </div>
      </div>

      <div className="brand_award_container">
        <div className="brand_award_content">
          <div className="brand_img">
            <img src={brandimg} alt="not" />
          </div>
          <div className="brand_info">
            <h2>INDIA BRAND ICON AWARD</h2>
            <p>
              The India Brand Icon Awards are Regarded as one of the most
              prestigious platform in the honour of the
            </p>
            <br />
            <p>
              entrepreneurs, Innovators and Achievers, the Program is going to
              observe the participations from the
            </p>
            <br />
            <p>
              various industry leaders and brands. This program is also a part
              of continued conversations...
            </p>
            <br />

            <button className="btn">
              <u>READ MORE</u>
            </button>
          </div>
        </div>
      </div>

      <div className="healthcare_award_container">
        <div className="healthcare_award_content">
          <div className="healthcare_img">
            <img src={healthcare} alt="not" />
          </div>
          <div className="healthcare_info">
            <h2>INTERNATIONAL HEALTHCARE AWARDS</h2>
            <p>
              TIME Cyber Media Pvt. Ltd. presents International Healthcare
              Awards that aim to recognize excellence in
            </p>
            <br />
            <p>
              the healthcare industry. The award felicitates individuals and
              organizations for their critical contributions
            </p>
            <br />
            <p>
              and services to the industry, by rewarding those who have played a
              significant role in increasing the
            </p>
            <br />
            <p>
              efficiency as well as performance of the industry as a whole.
              These exemplary performers, innovators
            </p>
            <br />
            <p>
              and visionaries in the healthcare industry epitomize the best that
              the healthcare industry has to offer and
            </p>
            <br />
            <p>
              their work sets an example for hard work, devotion and doing
              extraordinary service to humanity.
            </p>
            <button className="btn">
              <u>READ MORE</u>
            </button>
          </div>
        </div>
      </div>

      <div className="home_header">
        <h1 className="home_header">FQA</h1>
      </div>
      <Questions />

      <div className="home_header">
        <h1 className="home_header">OUR SERVICES</h1>
      </div>
      <Our_Services />

      <Footer />
    </>
  );
};

export default Home;
